export default __webpack_public_path__ + "static/media/angle-double-down.d8b8ea5e.svg";